import React from "react";
import { motion } from "framer-motion";

const Blog = () => {
  const posts = [
    {
      id: 1,
      title: "Tracking the Gentle Giants: A Gorilla Safari Experience in Uganda",
      excerpt:
        "Embark on a once-in-a-lifetime adventure into Bwindi Impenetrable Forest, where you’ll meet the magnificent mountain gorillas up close.",
      link: "#",
    },
    {
      id: 2,
      title: "10 Reasons Why Uganda Should Be Your Next Travel Destination",
      excerpt:
        "Explore the Pearl of Africa — from gorilla trekking and wildlife safaris to the source of the Nile and cultural festivals.",
      link: "#",
    },
    {
      id: 3,
      title: "How to Prepare for Your First Safari Adventure",
      excerpt:
        "A practical guide covering what to pack, safety tips, and how to make the most of your safari experience.",
      link: "#",
    },
    {
      id: 4,
      title: "Sustainable Travel: How Gorilland Travel Care Supports Eco-Tourism",
      excerpt:
        "Learn how our journeys are designed to protect wildlife, support local communities, and preserve the environment.",
      link: "#",
    },
    {
      id: 5,
      title: "Top 5 National Parks in East Africa for Wildlife Lovers",
      excerpt:
        "A roundup of breathtaking destinations every safari enthusiast should add to their bucket list.",
      link: "#",
    },
  ];

  return (
    <div className="min-h-screen bg-gray-50 py-16 px-6 md:px-20">
      {/* Page Header */}
      <motion.div
        className="text-center mb-12"
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7 }}
      >
        <h1 className="text-4xl font-bold text-green-800 mb-4">
          Gorilland Travel Care Blog
        </h1>
        <p className="text-lg text-gray-600 max-w-2xl mx-auto">
          Discover travel tips, safari stories, destination guides, and
          adventure inspiration from across Africa and beyond.
        </p>
      </motion.div>

      {/* Blog Grid */}
      <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-3">
        {posts.map((post, index) => (
          <motion.div
            key={post.id}
            className="bg-white rounded-2xl shadow-lg p-6 hover:shadow-2xl transition"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: index * 0.2 }}
          >
            <h2 className="text-xl font-semibold text-green-700 mb-2">
              {post.title}
            </h2>
            <p className="text-gray-600 mb-4">{post.excerpt}</p>
            <a
              href={post.link}
              className="text-green-700 font-medium hover:underline"
            >
              Read More →
            </a>
          </motion.div>
        ))}
      </div>

      {/* Subscribe Section */}
      <motion.div
        className="mt-16 text-center bg-green-700 text-white rounded-2xl p-10 shadow-lg"
        initial={{ opacity: 0, y: 40 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7 }}
      >
        <h2 className="text-2xl font-semibold mb-4">
          Stay Connected with Gorilland Travel Care
        </h2>
        <p className="mb-6">
          Subscribe to our newsletter and get travel updates, safari tips, and
          exclusive offers delivered straight to your inbox.
        </p>
        <div className="flex justify-center">
          <input
            type="email"
            placeholder="Enter your email"
            className="p-3 rounded-l-xl w-64 text-gray-800 focus:outline-none"
          />
          <button className="bg-yellow-400 text-green-900 px-5 py-3 rounded-r-xl font-semibold hover:bg-yellow-300 transition">
            Subscribe
          </button>
        </div>
      </motion.div>
    </div>
  );
};

export default Blog;
